<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Bridge Number List</h1>
        </div>
        <div class="col-sm-6 float-left add_btn" *ngIf="myrole=='1' || myrole=='6'">
            <a class="btn btn-success" (click)="showModal(bridge_blank)">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Bridge Number
            </a>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3">
                        <input class="form-control" type="text" [(ngModel)]="bridge" placeholder="Search" />
                    </div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Lead Catergory" [(ngModel)]="lead_category_filter"
                            (click)="setSearchValue('leadCategory')" multiple>
                            <input class="mySearchInput" #leadcategorySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'leadCategory')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="leadcategorySearch">
                            <mat-option [value]="catergory.id" *ngFor="let catergory of treatCategory">
                                {{catergory.name}}</mat-option>
                        </mat-select>
                    </div>


                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadBridgeList(0,perpage)">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                            class="fa fa-sync"></i> Reset Filters</button>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadBridgeList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>BRIDGE NAME</th>
                            <th>BRIDGE NUMBER</th>
                            <th>Lead Source</th>
                            <th>Treatment</th>
                            <th>LEAD CATERGORY</th>
                            <th>CAMPAIGN NAME</th>
                            <th>FORM LEAD SOURCE </th>
                            <th style="width: 100px;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let Bridge of bridgeList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{Bridge.bridge_name}} </td>
                            <td>{{Bridge.bridge_number}} </td>
                            <td>{{Bridge.lead_sourceName}} </td>
                            <td>{{Bridge.treatmentName}} </td>
                            <td>{{Bridge.categoryName}} </td>
                            <td>{{Bridge.campaign_name}} </td>
                            <td>{{Bridge.form_lead_source}} </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item cursor-pointer" (click)="showModal(Bridge.id)"><i
                                                class="fa fa-edit"></i> Update</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !bridgeList.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>


<!-- The Modal -->
<div class="modal fade" id="myModal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span *ngIf="!bridge_id">Add Bridge</span>
                    <span *ngIf="bridge_id">Update Bridge</span>
                </h4>
                <button type="button" class="close" (click)="hideModal()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="bridgeForm" (submit)="updateBridge()">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-6">
                                <label class="form-label">Bridge Name *</label>
                                <input type="text" formControlName="bridge_name" class="form-control" />
                                <div *ngIf="submitted && f.bridge_name.errors" class="invalid-feedback">
                                    <div *ngIf="f.bridge_name.errors.required">Bridge Name  is required</div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label">Bridge Number *</label>
                                <input type="text" formControlName="bridge_number"  class="form-control" [attr.disabled]="bridge_no_disabled?'':null"  />
                                <div *ngIf="submitted && f.bridge_number.errors" class="invalid-feedback">
                                    <div *ngIf="f.bridge_number.errors.required">Bridge Number is required</div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label mt-2">Lead Source *</label>
                                <mat-select placeholder="Lead Source" (click)="setSearchValue('LeadSource')"
                                    formControlName="leadsource_id">
                                    <input class="mySearchInput" #LeadSourceSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'LeadSource')"
                                        (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                        id="LeadSourceSearch">
                                    <mat-option [value]="klead.id"
                                        *ngFor="let klead of kal_lead">{{klead.source_name}}</mat-option>
                                </mat-select>
                                <div *ngIf="submitted && f.leadsource_id.errors" class="invalid-feedback">
                                    <div *ngIf="f.leadsource_id.errors.required">Lead Source is required</div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label mt-2">Lead Catergory</label>
                                <mat-select placeholder="Lead Catergory" (click)="setSearchValue('leadCategory')"
                                    formControlName="catergory_id">
                                    <input class="mySearchInput" #leadcategorySearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'leadCategory')"
                                        (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                        id="leadcategorySearch">
                                    <mat-option [value]="catergory.id" *ngFor="let catergory of treatCategory">
                                        {{catergory.name}}</mat-option>
                                </mat-select>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label mt-2">Treatment *</label>
                                <mat-select placeholder="Treatment" (click)="setSearchValue('treatment')"
                                    formControlName="treatment_id">
                                    <input class="mySearchInput" #treatmentSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                        (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                        id="treatmentSearch">
                                    <mat-option [value]="ltreatment.id"
                                        *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                                </mat-select>
                                <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                                    <div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label mt-2">Campaign Name</label>
                                <input type="text" formControlName="campaign_name" class="form-control" />
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label mt-2">Form Lead Source</label>
                                <input type="text" formControlName="form_lead_source" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="!bridge_id">Create Bridge</span>
                        <span *ngIf="bridge_id">Update Bridge</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>